// utils/rolePermissions/rolesA.ts - utils/rolePermissions/permissions.ts object split (part rolesA)

import { ALL_FEATURES } from './features.js';
import { ALL_MENUS } from './menus.js';

export const rolesA = {

  'Super Admin': {
    menus: ALL_MENUS.map(m => m.id),
    features: ALL_FEATURES.map(f => f.id),
  },

  'Admin': {
    menus: [
      'dashboard',
      'products', 'product_list', 'form_list', 'product_page', 'digital_products',
      'orders', 'order_list', 'abandoned_carts', 'digital_orders',
      'customers',
      'reports', 'ad_reports', 'cs_reports', 'stock_reports', 'finance_reports',
      'analytics_dashboard',
      'earnings',
      'settings', 'website_settings', 'brands', 'user_management', 'cs_management', 'cuan_rank',
      'tracking', 'error_logs', 'performance_dashboard', 'feature_requests',
      'wa_bot', 'prospek', 'ai_landing_page', 'toko_online',
      'iklan_automation',
      'cek_ongkir',
      'everpro', 'mengantar', 'lincah',
      'tiktok_download'
    ],
    features: [
      'export_csv', 'import_data', 'edit_product', 'delete_product', 'edit_form', 'delete_form', 'edit_landing_page',
      'delete_order', 'change_order_status', 'manual_order_creation', 'assign_order_cs',
      'view_earnings', 'view_cost_margin', 'manage_users', 'view_reports', 'edit_settings', 'manage_tracking', 'manage_error_logs', 'view_performance',
      'manage_whatsapp', 'view_whatsapp_logs', 'whatsapp_automation',
      'view_sales_stats', 'view_charts', 'view_top_products', 'view_top_advertisers', 'view_top_cs', 'view_recent_orders',
      'manage_prospek_followup', 'manage_prospek_checkout', 'manage_ads_automation'
    ],
  },

  'Keuangan': {
    menus: [
      'dashboard',
      'orders', 'order_list',
      'customers',
      'reports', 'cs_reports', 'finance_reports', 'analytics_dashboard',
      'earnings',
      'wa_bot', 'prospek'
    ],
    features: [
      'export_csv', 'view_earnings', 'view_cost_margin', 'view_reports',
      'view_sales_stats', 'view_charts', 'view_top_cs', 'view_recent_orders'
    ],
  }
};

